import { useTranslation } from 'react-i18next';
import { TableCell } from '@anytag/shared-atoms';
import { ColumnDef } from '@tanstack/react-table';
import { formatIntNumber } from '@anytag/shared-utils';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { FacebookPageAnalyticsPostsSortOrder, FacebookPageAnalyticsPostsPayload } from '@anytag/graphql';

export const useAnalyticsFacebookPostsListTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<FacebookPageAnalyticsPostsPayload>[] = [
    {
      accessorKey: 'post',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Posts'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.content || ''}
          thumbnail={row.original.image || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'reach',
      header: t<string>('HeaderColumn.Reach'),
      meta: { align: 'right', sortField: FacebookPageAnalyticsPostsSortOrder.AD_IMPRESSIONS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.adImpressions)} />
    },
    {
      accessorKey: 'engagement',
      header: t<string>('HeaderColumn.Engagement'),
      meta: { align: 'right', sortField: FacebookPageAnalyticsPostsSortOrder.ENGAGEMENT },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.engagement)} />
    },
    {
      accessorKey: 'reactions',
      header: t<string>('HeaderColumn.Reaction'),
      meta: { align: 'right', sortField: FacebookPageAnalyticsPostsSortOrder.REACTIONS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.reactions)} />
    },
    {
      accessorKey: 'comments',
      header: t<string>('HeaderColumn.Comment'),
      meta: { align: 'right', sortField: FacebookPageAnalyticsPostsSortOrder.COMMENT },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.comments)} />
    },
    {
      accessorKey: 'shares',
      header: t<string>('HeaderColumn.Share'),
      meta: { align: 'right', sortField: FacebookPageAnalyticsPostsSortOrder.SHARE },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.shares)} />
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      meta: { sortField: FacebookPageAnalyticsPostsSortOrder.POST_DATE },
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    }
  ];

  return { columns };
};
